module.exports = __webpack_public_path__ + "static/media/store-ad.f0b4bd36.svg";